import React, {Component} from 'react';
import {Col, Container, Row} from "mdbreact";
import { Player } from 'video-react';

import "./../../../node_modules/video-react/dist/video-react.css";

export default class HowItWorks extends Component {
    render() {
        return (
            <Container className="text-center rtl">
                <Row className="mt-5 py-1 justify-content-center">
                    <h2 className="text-center underline">آتلانتیس کارت چگونه کار می کنه</h2>
                </Row>
                <Row className="justify-content-center">
                    <p className="text-center">در این ویدیو شما با نحوه کار آتلانتیس کارت آشنا خواهید شد</p>
                </Row>
                <Row className="py-4 d-flex justify-content-center">
                    <Col xs="12" md="12" lg="12" className="text-center">

                        <Player
                            playsInline
                            poster="./assets/media/intro.jpg"
                            src="./assets/media/1.mp4"
                        />
                    </Col>
                </Row>
            </Container>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/howItWorks/HowItWorks.js